import React from 'react'
import { Box } from '@chatterbug/aaron'

import { t } from 'src/lib/i18n-react'

const lessons = (count: number, shorter = false) =>
  shorter ? '' : t('lesson |||| lessons', { smart_count: count })

const minutes = (count: number, shorter = false) =>
  shorter
    ? t('min |||| min', { smart_count: count })
    : t('minute |||| minutes', { smart_count: count })

export type Props = {
  completed: number
  goal: number
  unit?: 'minutes' | 'lessons'
}

const SingleStudyGoalProgress: React.FC<Props> = ({
  completed,
  goal,
  unit,
}) => {
  let textFunc
  if (unit === 'minutes') {
    textFunc = minutes
  } else if (unit === 'lessons') {
    textFunc = lessons
  }

  return (
    <Box
      as="p"
      fontWeight="bold"
      data-testid="progress"
      textAlign={{ mobile: 'left', tablet: 'right' }}
    >
      {completed}
      {textFunc && (
        <>
          <Box
            as="span"
            color="gray46"
            fontWeight="regular"
            display={{ _: 'none', tablet: 'inline' }}
          >
            {`/${goal} ${textFunc(goal)}`}
          </Box>
          <Box
            as="span"
            color="gray46"
            fontWeight="regular"
            display={{ _: 'inline', tablet: 'none' }}
          >
            {`/${goal} ${textFunc(goal, true)}`}
          </Box>
        </>
      )}
    </Box>
  )
}

export default SingleStudyGoalProgress
